import { Ams } from "../api";

export const fetchDailyMessages = () => (dispatch, getStore) => {
  Ams.getTodaysMessages()
    .then((response) => {
      dispatch(setDailyMessages(response.data.data));
    })
    .catch((e) => {
      console.error(e);
    });
};

export const setDailyMessages = (messages) => ({
  type: "SET_DAILYMESSAGE",
  messages,
});
